import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa";

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
  instagram_reel?: string;
}

const News = () => {
  const [searchNotFound, setSearchNotFound] = useState<string>('');
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [NewPopup, setNewsPopup] = useState(false);

  const [usersData, setUsersData] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async () => {

    console.log('Searching for:', searchQuery);

    try {
      // Make sure the searchQuery is not empty before making the request
      if (!searchQuery) {
        alert('Please enter a search term');
        return;
      }

      // Sending a GET request to the backend with the search query
      const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/news/search/${searchQuery}`);
      console.log('news data', response.data)
      setNewData(response.data);

      // Log the response data for debugging
      console.log('Search results:', response.data);
      setSearchNotFound('');
      // Handle the data (e.g., updating state, displaying results)
      // For example, you could update the state here
      // setSearchResults(response.data);

    } catch (error) {
      setSearchNotFound('Not Found')
      console.error('Error during search:', error);
    }
  };


  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };

  const closeNewspop = () => {
    setNewsPopup(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/news"
        );

        console.log('news data', response.data)
        setNewData(response.data);
        console.log("news data in a array", newData);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://rmbbackend.rmbjaipur.com/auth/inserdata"
        );

        console.log('media data inserted', response.data)
        setNewData(response.data);
        console.log("media data in a array", newData);
      } catch (error) {
        console.error("media data Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const response = await axios.get(
          "https://rmbbackend.rmbjaipur.com/auth/allusersinfo"
        );

        console.log("All users data:", response.data);
        setUsersData(response.data); // Set users data
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };

    fetchAllUserData();
  }, []);

  function deletePost(id: string): void {
    const confirmation = window.confirm('Are you sure you want to delete this post?');

    if (confirmation) {
      axios
        .delete(`https://rmbbackend.rmbjaipur.com/auth/news/${id}`)
        .then((response) => {
          // Handle the success case
          alert('Post deleted successfully');
          console.log(response.data); // Log the response or update your state/UI
          window.location.reload();
        })
        .catch((error) => {
          // Handle errors
          console.error('Error deleting post:', error);
          alert('Failed to delete the post. Please try again.');
        });
    }
  }



  return (
    <div>
      {/* news header  */}
      <div
        className="flex justify-between items-center sticky top-0 z-10 px-12  w-full left-0 right-0 h-[74px]"
        style={{
          WebkitBackdropFilter: 'blur(22px)',
          backdropFilter: 'blur(22px)',
        }}
      >

        <div className='flex justify-between cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2' onClick={() => openModal('')}>
          <BsPlusCircleFill />  <h6>Add Event</h6>
        </div>

        <div className='flex justify-between cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2' onClick={() => setNewsPopup(true)}>
          <BsPlusCircleFill />  <h6>Add Text News</h6>
        </div>

        <div>
          <div className='bg-transparent border h-[45px] border-darkblue px-2 rounded-lg flex justify-between items-center text-darkblue'>
            <input type="search" name="search" id="" className='placeholder-darkblue border-none outline-none bg-transparent'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder='Write here....' />
            <button
              className='cursor-pointer px-2 border-l border-darkblue h-full flex items-center justify-center'
              onClick={handleSearch} // You can define a handleSearch function to perform the search
            >
              Search
            </button>
          </div>
          {searchNotFound && <p className="text-red-500">{searchNotFound}</p>}
        </div>


      </div>

      <div>
        {NewPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto">
              {/* Close button */}
              {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
              <ModalNews onCloseNewsPop={closeNewspop} />
            </div>
          </div>
        )}

        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto">
              {/* Close button */}
              {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
              <Modal users={usersData} postId={selectedPostId} onClose={closeModal} />
            </div>
          </div>
        )}
        {newData.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-12">
            {newData.map((item) => (
              <div className='bg-white rounded-lg p-2 drop-shadow-md'>
                <img
                  className="h-[230px] object-cover w-full max-w-full rounded-lg"
                  src={
                    item.img
                      ? item.img.startsWith("http")
                        ? item.img // Use the full URL if already valid
                        : `https://rmbbackend.rmbjaipur.com/${item.img}` // Prepend base URL for relative paths
                      : "https://via.placeholder.com/150" // Placeholder image for missing URLs
                  }
                  alt={item.title || "Image"}
                />

                <h3 className='font-semibold text-lg py-4 '>{item.title}</h3>
                <div className='flex justify-between gap-4'>

                  <div className='flex w-[130px] justify-center cursor-pointer   py-2 border border-darkblue  text-darkblue items-center rounded-lg gap-2' onClick={() => openModal(item.id)}>
                    <CiEdit />  <h6>Edit Event</h6>
                  </div>

                  <div className='flex  w-[130px] justify-center cursor-pointer   py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2' onClick={() => deletePost(item.id)}>
                    <RiDeleteBin5Line />  <h6>Delete Event</h6>
                  </div>

                </div>

              </div>
            ))}
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>


    </div>
  )
}



interface ModalProps {
  postId?: string | null;
  onClose: () => void;
  users: { id: number; name: string; }[];
}

const Modal: React.FC<ModalProps> = ({ users, postId, onClose }) => {
  const [fileList, setFileList] = useState<File[]>([]);



  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return date.toISOString().split('T')[0]; // Extracts yyyy-MM-dd
  };

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    date: '',
    image: null as File | string | null,
    RMBiansOfMeeting: null as number | null,
    instagram_reel: '',
    mom_pdf: null as File | string | null
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');
  const [eventsList, setEventsList] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/events');
        setEventsList(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('Error fetching events in News Modal:', err);
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/news/${postId}`);

          const data = Array.isArray(response.data) ? response.data[0] : response.data;

          const { title, content, date, img: image, RMBiansOfMeeting, instagram_reel, mom_pdf } = data;

          setFormData({
            title: title || '',
            content: content || '',
            date: formatDate(date),
            image: image || null,
            RMBiansOfMeeting: RMBiansOfMeeting || null,
            instagram_reel: instagram_reel || '',
            mom_pdf: mom_pdf || null
          });

          setFileName(image || null);
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev: any) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
  };

  const handlegalleryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      setFileList(Array.from(files));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.title || !formData.content || !formData.date) {
      setError('Title, description, and date are required.');
      return;
    }

    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    data.append('date', formData.date);
    data.append('instagram_reel', formData.instagram_reel || '');

    if (formData.image instanceof File) {
      data.append('image', formData.image);
    } else if (fileName) {
      data.append('image', fileName);
    }

    if (formData.mom_pdf instanceof File) {
      data.append('mom_pdf', formData.mom_pdf);
    } else if (typeof formData.mom_pdf === 'string' && formData.mom_pdf) {
      data.append('mom_pdf', formData.mom_pdf);
    }

    if (formData.RMBiansOfMeeting) {
      data.append('RMBiansOfMeeting', String(formData.RMBiansOfMeeting));
    }



    fileList.forEach((file) => {
      data.append("images", file); // Append each file to the FormData object
    });


    console.log('Data data ' + formData.image);
    console.log('filename ' + fileName);



    console.log('Submitting form data:', {
      title: formData.title,
      content: formData.content,
      date: formData.date,
      image: formData.image,
      gallery: fileList
    });

    try {
      if (postId) {
        await axios.put(`https://rmbbackend.rmbjaipur.com/auth/news/${postId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('Post updated successfully');
      } else {
        await axios.post('https://rmbbackend.rmbjaipur.com/auth/news', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('Post created successfully');
      }
      onClose();
      // window.location.href  = '/dashboard';
    } catch (err: any) {
      console.error('Error submitting post:', err);
      const serverMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Unknown error';
      setError(`Failed to submit post: ${serverMsg}`);
    }
  };


  return (
    <div className="w-full max-w-5xl mx-auto bg-white p-8 rounded-2xl border border-slate-200 shadow-xl my-6">
      <div className="flex justify-between items-center border-b border-slate-200 pb-4 mb-6">
        <div>
          <span className="text-xs font-black uppercase text-amber-600 tracking-wider">Admin Post & Event Editor</span>
          <h2 className="text-2xl font-black text-[#02256D]">
            {postId ? '✏️ Edit Post / Event Highlights' : '➕ Create New Post / Event Highlights'}
          </h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-bold rounded-xl transition cursor-pointer"
        >
          ← Back to Post List
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Connect Event Dropdown */}
        <div>
          <label className="text-[#02256D] font-bold block mb-1 text-xs flex items-center justify-between">
            <span>🔗 Connect With Chapter Event / Meeting (Optional)</span>
            <span className="text-[10px] text-amber-600 font-semibold">Auto-fills Title, Date & Details</span>
          </label>
          <div className="mt-1 w-[100%] h-[46px] border px-2 border-[#FDBC12] bg-amber-50/50 rounded-lg flex justify-center items-center mb-4 shadow-sm">
            <select
              className="w-full border-none outline-none bg-transparent font-bold text-xs text-[#02256D]"
              onChange={(e) => {
                const selectedId = e.target.value;
                const ev = eventsList.find((item: any) => String(item.id) === selectedId);
                if (ev) {
                  setFormData((prev: any) => ({
                    ...prev,
                    title: ev.event_type || ev.title || prev.title,
                    content: ev.description || ev.content || prev.content,
                    date: ev.event_date ? ev.event_date.split('T')[0] : prev.date
                  }));
                }
              }}
            >
              <option value="">-- Select Chapter Event / Meeting to Auto-fill & Connect --</option>
              {eventsList.map((ev: any) => (
                <option key={ev.id} value={ev.id}>
                  {ev.event_type || ev.title} ({ev.event_date ? new Date(ev.event_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Event'}) - {ev.location || ''}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Title */}
        <div>
          <label className="text-[#030303] font-medium"> Post title</label>
          <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Write your post title here..."
              className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
              required
            />
          </div>
        </div>

        {/* RMBiansOfMeeting */}
        <div>
          <label className="text-[#030303] font-medium"> RMBians Of Meeting</label>
          <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
              name="RMBiansOfMeeting"
              id=""
              value={formData.RMBiansOfMeeting ?? ''} // Use '' if no value is selected
              className="w-[100%] border-none outline-none"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  RMBiansOfMeeting: e.target.value === '' ? null : Number(e.target.value), // Parse value as number or set to null
                })
              }
            >
              <option value="" disabled>
                Select RMBians Of Meeting
              </option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>


          </div>
        </div>

        {/* Instagram Reel Link */}
        <div>
          <label className="text-[#02256D] font-bold block mb-1 text-xs flex items-center gap-1.5">
            <FaInstagram className="text-pink-600 text-base" /> Instagram Reel Link (Optional)
          </label>
          <input
            type="text"
            name="instagram_reel"
            value={formData.instagram_reel}
            onChange={handleChange}
            placeholder="e.g. https://www.instagram.com/reel/C..."
            className="w-full p-2.5 border border-[#94A2B8] rounded-lg text-xs font-semibold outline-none focus:ring-2 focus:ring-pink-500 mb-4"
          />
        </div>

        {/* Minutes of Meeting (MoM) PDF Upload */}
        <div>
          <label className="text-[#02256D] font-bold block mb-1 text-xs flex items-center gap-1.5">
            📄 Upload Minutes of Meeting (MoM) PDF Document (Optional)
          </label>
          <input
            type="file"
            accept=".pdf,application/pdf"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setFormData((prev: any) => ({ ...prev, mom_pdf: file }));
            }}
            className="w-full p-2 border border-[#94A2B8] rounded-lg text-xs outline-none mb-2"
          />
          {typeof formData.mom_pdf === 'string' && formData.mom_pdf && (
            <p className="text-[11px] text-emerald-700 font-bold mb-4 flex items-center gap-1">
              ✓ Uploaded MoM PDF: <a href={`https://rmbbackend.rmbjaipur.com/${formData.mom_pdf.replace(/\\/g, '/')}`} target="_blank" rel="noopener noreferrer" className="underline hover:text-blue-800">{formData.mom_pdf.split('/').pop()}</a>
            </p>
          )}
        </div>

        {/* Content */}
        <div>
          <label className="text-[#030303] font-medium">Description</label>
          <textarea
            name="content"
            value={formData.content}
            onChange={handleChange}
            className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
            placeholder="Write your message here..."
            rows={4}
            required
          />
        </div>
        <div>
          <label className="text-[#030303] font-medium">Add Gallery</label>
          <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
            <RiGalleryUploadLine
              size={24}
              className="text-[30px] cursor-pointer"
              onClick={() => document.getElementById("gallery-image-upload")?.click()}
            />
            <input
              id="gallery-image-upload"
              type="file"
              accept="image/*"
              className="hidden"
              multiple // Allow multiple file selection
              onChange={handlegalleryChange}
            />
            {fileList.length > 0 ? (
              <ul className="text-[14px] text-[#02256d] mt-2">
                {fileList.map((file, index) => (
                  <li key={index} className="font-bold">
                    {file.name}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="font-bold text-[14px]">
                Drag and Drop or <span className="text-[#02256d]">click to upload</span>
              </p>
            )}
          </div>
        </div>

        {/* File Upload */}
        <div>
          <label className="text-[#030303]  font-medium">  Add thumbnail</label>
          <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">

            <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
              onClick={() => document.getElementById('file-upload')?.click()} />
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              className="hidden"
              name='image'

              onChange={handleFileChange}


            />
            {fileName ? (
              <p className="text-[14px] text-[#02256d] mt-2">
                Selected file: <span className="font-bold">{fileName}</span>
              </p>
            ) : (
              <p className="font-bold text-[14px]">
                Drag and Drop or{' '}
                <span className="text-[#02256d]">click to upload</span>
              </p>
            )}
          </div>

        </div>

        {/* Error Message */}
        {error && <p className="text-red-500">{error}</p>}


        <div className=' flex justify-between'>
          {/* Date */}
          <div className='flex flex-col'>
            <label htmlFor="Name" className="  text-[#030303] font-medium ">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="mt-1 w-[150px] bg-transparent placeholder-[#94A2B8] outline-none  border  border-[#94A2B8] rounded-md p-1 text-[14px]"
              required
            />
          </div>
          <div className='flex items-center'>
            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold' onClick={onClose}>Cancel</button>
            {/* Submit Button */}
            <button
              type="submit"
              className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
              disabled={!formData.title || !formData.content || !formData.date}
            >
              {postId ? 'Update Post' : 'Create Post'}
            </button>
          </div>


        </div>



      </form>
    </div>
  );
};

interface NewsProps {
  onCloseNewsPop: () => void;
}

const ModalNews: React.FC<NewsProps> = ({ onCloseNewsPop }) => {
  const [formData, setFormData] = useState({ title: "" });

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://rmbbackend.rmbjaipur.com/auth/newsheading");
        console.log("Fetched news heading data:", response.data);

        if (response.data && response.data.data && response.data.data.length > 0) {

          setFormData({ title: response.data.data[0].title });
        }
      } catch (error) {
        console.error("Failed to fetch news heading:", error);
      }
    };

    fetchData();
  }, []);

  console.log("form data title", formData.title);
  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.title) {
      alert("Please enter a title");
      return;
    }

    try {
      console.log("Updating news heading:", formData.title);
      await axios.put(
        "https://rmbbackend.rmbjaipur.com/auth/newsheading",
        { title: formData.title },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("News heading updated successfully");
      window.location.reload(); // Reload page to reflect changes
    } catch (error) {
      console.error("Failed to update news heading:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg p-6 rounded shadow-md relative">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Title Input */}
          <div>
            <label htmlFor="title" className="text-gray-800 font-medium">
              Post Title
            </label>
            <div className="mt-2 w-full h-12 border px-3 border-gray-300 rounded-lg flex items-center">
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Write your post title here..."
                className="w-full bg-transparent placeholder-gray-400 outline-none text-sm"
                required
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onCloseNewsPop}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600"
            >
              Update News Heading
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default News